import { ReactNode } from "react";
import { IoAlertCircle } from "react-icons/io5";
import { SUBSCRIPTION_STATUS } from "api/interfaces/subscription.interface";
import { SubscriptionKeyListStyled } from "pages/subscription/SubscriptionStyled";
import { WithTooltip } from "components/blocks/WithTooltip";

type Props = {
  status: SUBSCRIPTION_STATUS | string;
  showAlert: boolean;
  tooltip: ReactNode;
  children: ReactNode;
};

export default function StatusAlertBox({
  status,
  showAlert,
  tooltip,
  children,
}: Props): JSX.Element {
  return (
    <SubscriptionKeyListStyled.ExpireDateBox status={status}>
      {children}
      {showAlert && (
        <WithTooltip tooltip={tooltip}>
          <IoAlertCircle size={15} />
        </WithTooltip>
      )}
    </SubscriptionKeyListStyled.ExpireDateBox>
  );
}
